export default __webpack_public_path__ + "static/gis_widget-3afe4172e18293e31c9876450fd5d9b1.png";